import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    type: "", // info, success, warning, error
    message: ""
};

export const alertSlice = createSlice({
    name: 'alert',
    initialState,
    reducers: {
        openAlert: (state, action) => action.payload,
        closeAlert: state => initialState
    }
});

export const {openAlert, closeAlert} = alertSlice.actions;

export const selectAlert = state => state.alert;

export default alertSlice.reducer;